<div class="container-fluid">
  <form [formGroup]="shiftsForm">
    <div class="input-group mb-3">
      <input type="date" (change)="get()" formControlName="start" class="form-control">
      <span class="input-group-text">-</span>
      <input type="date" (change)="get()" formControlName="end" class="form-control">
      <select class="form-control" (change)="get()" *ngIf="customers.length > 1" formControlName="customer">
        <option ngValue="all" i18n>All locations</option>
        <option *ngFor="let customer of customers" [ngValue]="customer.id">{{ customer.name }}</option>
      </select>
    </div>
  </form>

  <p *ngIf="shifts.length == 0" class="text-center" i18n>No orders found.</p>

  <ng-container *ngFor="let shift of shifts; let i = index">
    <h5 *ngIf="i === 0 || (shifts[i-1].start | date: 'yyyy-MM-dd') != (shift.start | date: 'yyyy-MM-dd')"
      class="shifts-date">{{ shift.start |
      date: 'EE' }} {{ shift.start | date: 'shortDate' }}</h5>
    <div class="card mb-3 cursor-pointer" (click)="edit(shift)">
      <div class="card-header rounded d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <img [src]="shift.employee.picture" style="object-fit: cover; border-radius: 50%; width: 4rem; height: 4rem;"
            class="me-3">
          <div class="ps-0">
            <h5 class="card-title mb-0">
              <span *ngIf="shift.confirmed_customer" class="text-success" title="Confirmed" i18n-title>✓</span>
              <span *ngIf="shift.customer.type != 'individual'">{{ shift.customer.name }}</span> 
              <span *ngIf="shift.employee">{{ shift.employee.first_name }}&nbsp;&bull;&nbsp;</span>
              <span *ngIf="shift.customer.type != 'individual'">{{ shift.customer.name }}&nbsp;&bull;&nbsp;</span> 
              <span>{{ shift.assignment | translateField: 'name' }}</span>
            </h5>
            <div class="text-muted text-nowrap">{{ shift.customer.street_address }} {{ shift.customer.office }} {{
              shift.customer.city }}</div>
            <div class="text-muted text-nowrap">
              {{ shift.start | date: 'shortTime' }} - {{ shift.end | date: 'shortTime' }} ({{
              msToHumanDuration(shift.duration * 60 * 60 * 1000) }})
            </div>
            <ng-container *ngIf="shift.checkin_start">
              <div *ngIf="!shift.checkin_end" class="text-success" i18n>In progress</div>
              <div *ngIf="shift.checkin_end" class="text-success" i18n>Completed</div>
            </ng-container>
            <ng-container *ngIf="!shift.checkin_start">
              <div *ngIf="shift.type == 'normal' && shift.confirmed_employee && shift.customer_notified_start"
                class="text-success" i18n>Partner is on their way</div>
              <div *ngIf="shift.type == 'normal' && shift.confirmed_employee && !shift.customer_notified_start"
                class="text-success" i18n>Accepted by partner
              </div>
              <div *ngIf="shift.type == 'normal' && !shift.confirmed_employee && !shift.customer_reminded_start">
                <span class="text-info" i18n>Waiting for confirmation</span>&nbsp;<span class="text-muted"><ng-container
                    i18n>(deadline:</ng-container>&nbsp;{{
                  shift.employee_confirmation_deadline | date: 'shortTime' }})</span>
              </div>
              <div *ngIf="shift.type == 'rejected'" class="text-danger" i18n>Refused by partner</div>
              <div *ngIf="shift.type == 'ignored'" class="text-danger" i18n>Not accepted by partner</div>
              <div *ngIf="shift.type == 'cancelled_customer'" class="text-danger" i18n>Cancelled by customer</div>
              <div *ngIf="shift.type == 'cancelled_employee'" class="text-danger" i18n>Cancelled by partner</div>
              <div *ngIf="shift.type == 'payment_failed'" class="text-danger" i18n>Payment failed</div>
            </ng-container>
          </div>
        </div>
        <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.5rem;" class="ms-3"></fa-icon>
      </div>
    </div>
  </ng-container>
</div>